import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

const LegalPage = ({ kind }) => {
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    api.get("/settings").then((r) => {
      const s = r.data || {};
      if (kind === "privacy") {
        setText(s.privacy_text || "");
        setTitle("Política de Privacidad");
        document.title = "Política de Privacidad · " + (s.site_name || "Secret Angels");
      } else {
        setText(s.terms_text || "");
        setTitle("Términos y Condiciones");
        document.title = "Términos y Condiciones · " + (s.site_name || "Secret Angels");
      }
    }).catch(() => {});
  }, [kind]);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-xs tracking-[0.3em] uppercase text-[#6B6A63]">Documentación legal</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1A2118] mt-2 mb-8">{title}</h1>
        <article className="bg-white border border-[#E5E2D9] rounded-2xl p-6 sm:p-8 whitespace-pre-wrap text-[#1A2118] text-sm leading-relaxed">
          {text}
        </article>
        <div className="mt-8 text-sm">
          <Link to="/" className="text-[#364531] underline">← Volver al inicio</Link>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
